import React from 'react'
import { Container, Typography } from '@material-ui/core'
import makeStyles from '@material-ui/core/styles/makeStyles'

const useStyles = makeStyles((theme) => ({
    footer: {
        marginTop: 'auto',
        color: 'white',
        zIndex: 1,
    },
    footerTopBar: {
        padding: '1rem 0',
        backgroundColor: theme.palette.secondary.main,
        textAlign: 'center',
    },
    footerBottomBar: {
        padding: '1rem 0',
        backgroundColor: '#898989',
    },
    footerLink: {
        color: 'white',
        fontWeight: 'bold',
    },
}))

const CreateACardFooter = (props) => {
    const classes = useStyles()
    return (
        <>
            <footer className={classes.footer}>
                <div className={classes.footerTopBar}>
                    <Container maxWidth="lg">
                        <Typography variant="h6">
                            Have questions?{' '}
                            <a
                                href={props.faqUrl}
                                className={classes.footerLink}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                View our FAQs
                            </a>
                        </Typography>
                    </Container>
                </div>
                <div className={classes.footerBottomBar}>
                    <Container maxWidth="lg">{props.content}</Container>
                </div>
            </footer>
        </>
    )
}

export default CreateACardFooter
